<template>
    <el-container class="bg-white" style="height: 100vh;">
        <el-header class="shadow-md" style="padding: 10px 6px; height: 52px;">
            <div class="flex">
                <div class="flex flex-grow">
                    <div class="flex flex-grow md:flex-grow-0">
                        <el-button
                            class="w-24 md:w-40"
                            type="primary" 
                            :style="{ backgroundColor: defaultActive !== ROUTES.ALARM ? '#c2dbf0' : '' }"
                            :text="defaultActive !== ROUTES.ALARM"
                            :bg="defaultActive !== ROUTES.ALARM"
                            @click="goToPath(ROUTES.ALARM)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">home</span>
                            </el-icon>
                            <span>
                                <span class="md:hidden">Limitock</span>
                                <span class="hidden md:block">Limitock期限管理</span>
                            </span>
                        </el-button>

                        <!-- <el-button
                            class="w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.INVENTORY ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.INVENTORY ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.INVENTORY"
                            :bg="defaultActive !== ROUTES.INVENTORY"
                            @click="goToPath(ROUTES.INVENTORY)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">quick_reference_all</span>
                            </el-icon>
                            <span class="hidden md:block">在庫一覧</span>
                        </el-button> -->
                        <!-- 在庫一覧2 開発中-->
                        <el-button
                            class="w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.INVENTORY2 ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.INVENTORY2 ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.INVENTORY2"
                            :bg="defaultActive !== ROUTES.INVENTORY2"
                            @click="goToPath(ROUTES.INVENTORY2)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">quick_reference_all</span>
                            </el-icon>
                            <span class="hidden md:block">在庫一覧</span>
                        </el-button> 

                        <!-- ==================== [Change Block Start] 可回退: 头部【払い出し】菜单显示条件放宽 ==================== -->
                        <!-- 修改前:
                        <el-button
                            v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                            ...>
                        -->
                        <el-button
                            v-if="canShowPaymentMenu"
                            class="w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.PAYMENT ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.PAYMENT ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.PAYMENT"
                            :bg="defaultActive !== ROUTES.PAYMENT"
                            @click="goToPath(ROUTES.PAYMENT)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">trolley</span>
                            </el-icon>
                            <span class="hidden md:block">払い出し</span>
                        </el-button>
                        <!-- ==================== [Change Block End] 可回退 ==================== -->

                        <!-- <el-button
                            class="w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.CONSTANT_MANAGE ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.CONSTANT_MANAGE ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.CONSTANT_MANAGE"
                            :bg="defaultActive !== ROUTES.CONSTANT_MANAGE"
                            @click="goToPath(ROUTES.CONSTANT_MANAGE)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">checklist</span>
                            </el-icon>
                            <span class="hidden md:block">定数管理</span>
                        </el-button> -->

                        <!-- 定数管理2 開発中-->
                        <el-button
                            class="w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.CONSTANT_MANAGE2 ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.CONSTANT_MANAGE2 ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.CONSTANT_MANAGE2"
                            :bg="defaultActive !== ROUTES.CONSTANT_MANAGE2"
                            @click="goToPath(ROUTES.CONSTANT_MANAGE2)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">checklist</span>
                            </el-icon>
                            <span class="hidden md:block">定数管理</span>
                        </el-button>
                    </div>
                    
                    <div class="flex flex-grow-0 md:flex-grow">
                        <el-dropdown v-if="loginUserRole === ROLES.SYSTEM || loginUserRole === ROLES.ADMIN">
                            <el-button
                                class="ml-3 w-8 md:w-36"
                                type="info" 
                                :color="settingPaths.includes(defaultActive) ? '#000000' : ''"
                                :style="{ backgroundColor: !settingPaths.includes(defaultActive) ? '#b7b7b7' : '' }"
                                :text="!settingPaths.includes(defaultActive)"
                                :bg="!settingPaths.includes(defaultActive)">
                                <el-icon>
                                    <span class="material-symbols-outlined text-xl">settings</span>
                                </el-icon>
                                <span class="hidden md:block">システム設定</span>
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM"
                                        @click="goToPath(ROUTES.ORGANIZATION)">組織マスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM"
                                        @click="goToPath(ROUTES.DEPARTMENT)">部門マスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM || loginUserRole === ROLES.ADMIN"
                                        @click="goToPath(ROUTES.USER)">ユーザーマスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM || loginUserRole === ROLES.ADMIN"
                                        @click="goToPath(ROUTES.CATEGORY)">カテゴリマスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM || loginUserRole === ROLES.ADMIN"
                                        @click="goToPath(ROUTES.MATERIAL)">アイテムマスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM"
                                        @click="goToPath(ROUTES.JANCODE)">JANコードマスタ</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM || loginUserRole === ROLES.ADMIN"
                                        @click="goToPath(ROUTES.LOG)">履歴確認</el-dropdown-item>

                                    <el-dropdown-item v-if="loginUserRole === ROLES.SYSTEM"
                                        @click="goToPath(ROUTES.SETTINGS)">環境設定</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>

                        <el-button
                            class="mx-3 w-8 md:w-28"
                            type="info" 
                            :color="defaultActive === ROUTES.PERSONAL_SETTINGS ? '#000000' : ''"
                            :style="{ backgroundColor: defaultActive !== ROUTES.PERSONAL_SETTINGS ? '#b7b7b7' : '' }"
                            :text="defaultActive !== ROUTES.PERSONAL_SETTINGS"
                            :bg="defaultActive !== ROUTES.PERSONAL_SETTINGS"
                            @click="goToPath(ROUTES.PERSONAL_SETTINGS)">
                            <el-icon>
                                <span class="material-symbols-outlined text-xl">person</span>
                            </el-icon>
                            <span class="hidden md:block">個人設定</span>
                        </el-button>
                    </div>
                </div>

                <!-- logout部 -->
                <span class="mt-1 mr-3 hidden md:inline">{{ getUserName() }}</span>
                <el-button
                    class="w-8"
                    type="info" 
                    style="background-color: #b7b7b7;"
                    text
                    bg
                    @click="logout">
                    <el-icon>
                        <span class="material-symbols-outlined text-xl">logout</span>
                    </el-icon>
                </el-button>
            </div>
        </el-header>

        <!-- 主显示 -->
        <el-main style="padding: 0px;">
            <router-view />
        </el-main>
    </el-container>
</template>


<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { Action, ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';
import axios from 'axios';
import { ROLES, ROUTES } from '@/config/constants';

export default defineComponent({
    name: 'Layout',
    setup() {
        const defaultActive = ref<string>(ROUTES.ALARM);

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';
        // ==================== [Change Block Start] 可回退: 头部菜单可见性新增组织开关判定 ====================
        // 修改前:
        // const canShowPaymentMenu =
        //     loginUserRole === ROLES.SYSTEM ||
        //     (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead);
        const loginUserOrgSubPayToHeadEnabled = localStorage.getItem('is_sub_pay_to_head_enabled') === '1';
        const canShowPaymentMenu =
            loginUserRole === ROLES.SYSTEM ||
            (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead) ||
            loginUserOrgSubPayToHeadEnabled;
        // ==================== [Change Block End] 可回退 ====================

        const settingPaths = [
            ROUTES.ORGANIZATION, 
            ROUTES.DEPARTMENT, 
            ROUTES.USER, 
            ROUTES.CATEGORY, 
            ROUTES.MATERIAL,
            ROUTES.JANCODE, 
            ROUTES.LOG, 
            ROUTES.SETTINGS,
        ];

        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }

            const path = router.currentRoute.value.path.replace(/^\/|\/$/g, '');
            const allowedPaths = [
                ...settingPaths,
                ROUTES.INVENTORY,
                ROUTES.PAYMENT,
                ROUTES.INVENTORY2,
                ROUTES.CONSTANT_MANAGE,
                ROUTES.CONSTANT_MANAGE2,
                ROUTES.PERSONAL_SETTINGS,
            ];
            if(allowedPaths.includes(path)){
                defaultActive.value = path;
            }else{
                defaultActive.value = ROUTES.ALARM;
            }
        });

        const goToPath = (path: string) => {
            router.push(`/${path}`);
            defaultActive.value = path;
        }

        /**
         * ログアウト
         */
        const logout = async () => {
            ElMessageBox.confirm('ログアウトしますか？', '確認', {
                confirmButtonText: 'OK',
                callback: async (action: Action) => {
                    if (action === 'confirm') {
                        // 调用服务端logout
                        await axios.post('/api/logout');

                        localStorage.removeItem('token');
                        localStorage.removeItem('role');
                        localStorage.removeItem('user_id');
                        localStorage.removeItem('user');
                        localStorage.removeItem('organization_id');
                        localStorage.removeItem('organization_name');
                        localStorage.removeItem('department_id');
                        localStorage.removeItem('department_name');
                        localStorage.removeItem('is_head');
                        localStorage.removeItem('is_pay_must');
                        // ==================== [Change Block Start] 可回退: 退出登录时清理新增缓存 ====================
                        // 修改前:
                        // (无 is_sub_pay_to_head_enabled 清理)
                        localStorage.removeItem('is_sub_pay_to_head_enabled');
                        // ==================== [Change Block End] 可回退 ====================
                        router.push(`/${ROUTES.LOGIN}`);
                        ElMessage.info(`ログアウトしました！`)

                    }
                }
            })
        }

        /**
         * 获取用户名
         */
        // 不需要 async，直接返回字符串即可
        const getUserName = () => {
            const userInfo = localStorage.getItem('user');
            if (userInfo) {
                return userInfo;
            }
            return '';
        }


        return {
            ROLES,
            ROUTES,
            loginUserRole,
            loginUserRoleIsHead,
            canShowPaymentMenu,
            settingPaths,
            defaultActive,
            goToPath,
            logout,
            getUserName,
        }
    },
});
</script>
<style scoped>
    .el-button:focus,
    .el-button:active {
        outline: none !important;
        box-shadow: none !important;
    }

    /* 修改 el-dropdown-menu hover 颜色 */
    ::v-deep(.el-dropdown-menu__item:hover) {
        background-color: #b7b7b7; /* 设置背景颜色为 primary 色 */
        color: #fff; /* 设置文字颜色为白色 */
    }
</style>